import script from "./Biology.vue?vue&type=script&setup=true&lang=js"
export * from "./Biology.vue?vue&type=script&setup=true&lang=js"

import "./Biology.vue?vue&type=style&index=0&id=791ef695&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-791ef695"]])

export default __exports__